import { Navigate, Outlet } from 'react-router-dom';
import { DashboardLink } from 'utils/link';
import useUserHeader from 'hooks/use_user_header';
import Loader from 'components/layout/loader';

const PrivateAdminRoute = () => {
  const { user, loading } = useUserHeader();

  if (loading) {
    return <Loader />;
  }

  if (!user.adminRole) {
    return <Navigate to={DashboardLink()} replace />;
  }

  return <Outlet />;
};

export default PrivateAdminRoute;
